import styled from 'styled-components';

export const CornerWrapper = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  border: 1px solid var(--border-dark, #a2a7ab);
  opacity: 0.9;
  background: var(--white, #fff);
  width: 28px;
  height: 28px;

  &:hover {
    cursor: pointer;
  }
`;
